/* eslint-disable */
import { callStatic, Review } from 'services/api-service'

/**
 * Get translated review data by id and target language
 *
 * @method
 * @name ApiService#getReviewTranslatedData
 * @param {string} locale -
 * @param {integer} id -
 */
function getReviewTranslatedData(parameters: { locale: string; id: number }): Promise<Review> {
  return callStatic<Review>('/sitedata/{siteKey}/translate/review/{id}/{locale}', parameters, [
    'locale',
    'id'
  ])
}

export default { getReviewTranslatedData }
